import React, { useEffect, useState } from "react";
import getForm from "lib/getForm";
import CalculatorForm from "components/Form/CalculatorForm";
import CalculatorFormSkeleton from "components/Form/CalculatorFormSkeleton";

export default function ParagraphCalculator({ data }) {
  const [form, setForm] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const webformId =
    data.field_calculator.resourceIdObjMeta.drupal_internal__target_id;

  useEffect(() => {
    if (typeof form === "undefined") {
      const controller = new AbortController();
      getForm(webformId, true, controller.signal)
        .then((fields) => setForm({ id: webformId, fields }))
        .catch(console.error)
        .finally(() => setIsLoading(false));
      return () => controller.abort();
    }
    return undefined;
  }, [webformId]);

  return (
    <div className="mx-auto lg:max-w-screen-lg h-full">
      {data.field_title && (
        <h2 className="mb-8 font-important text-4xl">{data.field_title}</h2>
      )}
      {isLoading ? <CalculatorFormSkeleton /> : <CalculatorForm {...form} />}
    </div>
  );
}
